import { render, staticRenderFns } from "./_record_message_fake_loading.vue?vue&type=template&id=400e9f07&scoped=true&"
import script from "./_record_message_fake_loading.vue?vue&type=script&lang=js&"
export * from "./_record_message_fake_loading.vue?vue&type=script&lang=js&"
import style0 from "./_record_message_fake_loading.vue?vue&type=style&index=0&id=400e9f07&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400e9f07",
  null
  
)

export default component.exports